<template>
  <Layout>
    <div class="content is-size-7 p-md">
      <GameTileList :games="games" />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'
import GameTileList from '@/components/LangGG/GameTileList'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    Layout,
    GameTileList
  },
  computed: {
    ...mapState({
      games: state => state.games.games
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/Home.vue